const earningsDrilldownES = {
    "view": {
        "form": {
            "label": {
                "filters": "Filtros",
                "monthRange": "Rango de Meses",
                "startingMonth": "Mes de Inicio",
                "endingMonth": "Mes de Fin",
                "label": "Etiqueta",
                "store": "Tienda",
                "release": "Lanzamiento",
                "track": "Pista",
                "country": "País",
                "subuser": "Subusuario",
                "fetchingEarnings": "Obteniendo estadísticas de ganancias de la base de datos"
            },
            "button": {
                "generateReport": "Generar Informe",
                "resetFilters": "Restablecer Filtros"
            },
            "options": {
                "store": {
                    "selectStore": "Seleccionar Tienda",
                    "allStores": "Todas las Tiendas"
                },
                "label": {
                    "selectLabel": "Seleccionar Etiqueta"
                },
                "country": {
                    "allCountries": "Todos los Países"
                },
                "release": {
                    "allReleases": "Todos los Lanzamientos"
                },
                "track": {
                    "allTracks": "Todas las Pistas"
                },
                "subuser": {
                    "selectSubuser": "Seleccionar Subusuario"
                },
                "period": {
                    "selectMonthRange": "Seleccionar Rango de Meses",
                    "last3Reports": "Últimos 3 Informes",
                    "last6Reports": "Últimos 6 Informes",
                    "last12Reports": "Últimos 12 Informes",
                    "custom": "Personalizado"
                }
            },
            "validation": {
                "monthRangeRequired": "* El filtro de Rango de Meses es obligatorio",
                "labelRequired": "* El filtro de Etiqueta es obligatorio"
            }
        },
        "royaltiesSummary": {
            "title": "Resumen de Regalías",
            "subtitle": "Resumen del Rango de Meses seleccionado",
            "label": {
                "monthRangeText": "Últimos 12 Estados de Cuenta",
                "revenueEUR": "Ingresos (€)",
                "combinedRevenue": "Ingresos Combinados",
                "combinedRevenueEUR": "Ingresos Combinados (€)",
                "otherStores": "Otras Tiendas"
            }
        },
        "storeWiseRevenuePercentage": {
            "title": "Porcentaje de Ingresos por Tienda"
        },
        "storeWiseRevenueBreakdown": {
            "title": "Desglose de Ingresos por Tienda",
            "label": {
                "revenue": "Ingresos"
            }
        },
        "revenueByTerritory": {
            "title": "Ingresos por Territorio"
        },
        "top5Releases": {
            "title": "Top 5 Lanzamientos",
            "table": {
                "column": {
                    "releaseName": "Nombre del Lanzamiento",
                    "revenue": "Ingresos"
                }
            }
        },
        "top5Tracks": {
            "title": "Top 5 Pistas",
            "table": {
                "column": {
                    "trackName": "Nombre de la Pista",
                    "revenue": "Ingresos"
                }
            }
        },
        "message": {
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor <1>reanuda</1> tu suscripción para disfrutar de esta función.",
            "subscriptionUpgrade": "Tu plan de suscripción actual no soporta esta función. Por favor <1>mejora</1> tu plan de suscripción para disfrutar de esta función."
        }
    }
};

export default earningsDrilldownES;